import { render, staticRenderFns } from "./NoticesRecharge.vue?vue&type=template&id=f994a4d0"
import script from "./NoticesRecharge.vue?vue&type=script&lang=js"
export * from "./NoticesRecharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports